import React, { useState, useEffect, useMemo, useRef } from "react";
import "./Header.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import Nav from "react-bootstrap/Nav";
import Sms from "../CommonPage/Home/Animation/chatbot/Sms";
import { ClipLoader } from "react-spinners";

import Cookies from "js-cookie";
import { useContext } from "react";
import { Context } from "../../utils/context";
import NotificationModal from "../CommonPage/NotificationPage/NotificationModal";
import { BannersIDS, commonBannerApi } from "../../utils/commonBannerApi";
import Login_As_Modal from "../CommonPage/Login_As_Modal/Login_As_Modal";
import { Navbar, Offcanvas } from "react-bootstrap";
import SearchBar from "../CommonPage/Home/Banner/SearchBar/SearchBar";
import { faBarsStaggered } from "@fortawesome/free-solid-svg-icons";
import ProfileOffcanvas from "./ProfileOffcanvas/ProfileOffcanvas";
const SabKaBaap = () => {
  const [modalShow, setModalShow] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const [showServicesMenu, setShowServicesMenu] = useState(false);
  const [modalPostJobModalShow, setPostJobModalShow] = useState(false);

  useState(false);
  const navigate = useNavigate();
  const {
    ReactLoader,
    setReactLoader,
    getData,
    setSignin,
    signin,
    setUsertype,
    userType,
    jobSeekerData,
    setRecruiterData,
    userdata,
  } = useContext(Context);

  console.log(jobSeekerData, "jobSeekerData");

  const [authToken, setAuthToken] = useState(null);
  const [authType, setAuthType] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const browseJob = () => {
    const featuredCategoryElement =
      document.querySelector(".Featured_Category");
    if (featuredCategoryElement) {
      featuredCategoryElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const logout = async () => {
    await setSignin(false);
    await setUsertype("");
    await Cookies.remove("echohouse_website");
    await Cookies.remove("jwtType");
    await setAuthToken(null);
    await setAuthType(null);
    await setRecruiterData({});
    await setSignin(false);
    navigate("/");
  };
  const [notifications, setNotification] = useState();
  const getNotifications = async () => {
    const res = await getData(`/common/notifications`);
    if (res?.success) {
      setNotification(res.data);
    }
  };

  useEffect(() => {
    if (signin) {
      getNotifications();
      setAuthToken(Cookies.get("echohouse_website"));
      setAuthType(Cookies.get("jwtType"));
    } else {
      setAuthToken(null);
      setAuthType(null);
    }
    setReactLoader(false);
  }, [signin, userType]);

  const [imgSrc, setImgSrc] = useState([]);

  const getBanners = async () => {
    try {
      const res = await commonBannerApi(BannersIDS.HeaderBanner);
      if (res?.success) {
        setImgSrc(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  const imgSrcNew = useMemo(() => imgSrc.map((item) => item?.image), [imgSrc]);

  const location = useLocation();

  const [showMenu, setShowMenu] = useState(false);

  const { Select2Data, setCitySearch } = useContext(Context);

  const [cities, setCities] = useState([]);
  const [selectCity, setSelectCity] = useState(null);
  const [searchTitle, setSearchTitle] = useState("");
  const [selectedExperience, setSelectedExperience] = useState(null);

  const experienceOptions = [
    { value: "0", label: "Fresher (0 Years)" },
    { value: "1", label: "1 Year" },
    { value: "2", label: "2 Years" },
    { value: "3", label: "3 Years" },
    { value: "5", label: "5+ Years" },
  ];

  useEffect(() => {
    getMasters();
  }, []);

  const getMasters = async () => {
    const res = await getData("/without-login/master/all-cities");

    if (res?.success) {
      setCities(await Select2Data(res.data, "city_id"));
    }
  };

  const handleSearch = () => {
    setCitySearch(selectCity);

    navigate(
      `/jobexp?id=${searchTitle}&city_id=${selectCity?.value || ""}&experience=${
        selectedExperience?.value || ""
      }`,
    );
  };

  const headerRef = useRef(null);

  useEffect(() => {
    const setHeaderHeight = () => {
      if (headerRef.current) {
        document.documentElement.style.setProperty(
          "--header-height",
          `${headerRef.current.offsetHeight}px`,
        );
      }
    };
    setHeaderHeight();
    window.addEventListener("resize", setHeaderHeight);
    return () => window.removeEventListener("resize", setHeaderHeight);
  }, [authType, authToken]);
  return (
    <>
      <NotificationModal show={modalShow} onHide={() => setModalShow(false)} />
      {ReactLoader ? (
        <ClipLoader color="#36d7b7" />
      ) : (
        <>
          {/* Recruiter header */}
          {authType === "Recruiter" && (
            <section className="Header desktopview-recruiter-header">
              <div className="container-lg p-0 ">
                <nav className="navbar navbar-expand-md">
                  <div className="container-fluid">
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span className="navbar-toggler-icon"></span>
                    </button>

                    <div
                      className="collapse navbar-collapse  justify-content-between"
                      id="navbarSupportedContent"
                    >
                      <div className="left_side_navs">
                        <Link className="navbar-brand hiclousia_logo " to="/">
                          <img
                            className="hiclousia_logo"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Images/logo/header_logo.png"
                            }
                          />
                        </Link>
                        <ul className="navbar-nav ">
                          <li className="nav-item ">
                            <NavLink
                              className="nav-link header-menu"
                              activeclassname="active"
                              to="/dashboardmain"
                            >
                              Dashboard
                            </NavLink>
                          </li>

                          <li className="nav-item ">
                            <NavLink
                              className="nav-link header-menu"
                              activeclassname="active"
                              to="/talentPool"
                            >
                              Talent Pool
                            </NavLink>
                          </li>

                          <li className="nav-item ">
                            <NavLink
                              className="nav-link header-menu"
                              activeclassname="active"
                              to="/getotp"
                            >
                              Job Packages
                            </NavLink>
                          </li>

                          <li
                            className="nav-item mega-menu-parent"
                            onMouseEnter={() => setShowServicesMenu(true)}
                            onMouseLeave={() => setShowServicesMenu(false)}
                          >
                            <NavLink
                              className="nav-link header-menu"
                              to="/career-services"
                            >
                              Services
                              <i className="fa-solid fa-angle-down ms-1"></i>
                            </NavLink>

                            <div
                              className={`mega-menu ${showServicesMenu ? "show" : ""}`}
                              onMouseEnter={() => setShowServicesMenu(true)}
                              onMouseLeave={() => setShowServicesMenu(false)}
                            >
                              <div className="mega-column">
                                <h5>Career Solutions</h5>

                                <NavLink to="/career-booster" target="_blank">
                                  Featured Profile
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Profile Highlighter
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Career Booster
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Resume Writing
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Resume Builder
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Linkedin Makeover
                                </NavLink>
                              </div>

                              <div className="mega-column">
                                <h5>Prep</h5>

                                <NavLink to="/service-prep" target="_blank">
                                  Interview Preparation
                                </NavLink>
                              </div>

                              <div className="mega-column">
                                <h5>Learn</h5>

                                <NavLink
                                  to="https://profcyma.com/"
                                  target="_blank"
                                >
                                  Degree Programs
                                </NavLink>

                                <NavLink
                                  to="https://profcyma.com/"
                                  target="_blank"
                                >
                                  Certification
                                </NavLink>

                                <NavLink
                                  to="https://profcyma.com/"
                                  target="_blank"
                                >
                                  GenAI Course
                                </NavLink>
                              </div>

                              <div className="mega-column">
                                <h5>Career Advice</h5>

                                <NavLink
                                  to="https://profcyma.com/"
                                  target="_blank"
                                >
                                  Career Advice
                                </NavLink>
                              </div>

                              <div className="mega-column">
                                <h5>Network</h5>

                                <NavLink to="/career-booster" target="_blank">
                                  Mentor Connect
                                </NavLink>
                              </div>
                            </div>
                          </li>

                          <li className="nav-item ">
                            <NavLink
                              className="nav-link header-menu"
                              activeclassname="active"
                              to="/career-solutions"
                            >
                              Career Solutions
                            </NavLink>
                          </li>

                          <li className="nav-item">
                            <NavLink className="nav-link" exact="true">
                              {authToken === null ? (
                                <Link to="/getotp">
                                  <p className="mb-0">Post Job</p>
                                </Link>
                              ) : userdata?.type === "Recruiter" ? (
                                <Link to="/dashboardmain">
                                  <p className="mb-0">Post Job</p>
                                </Link>
                              ) : (
                                <p
                                  className="mb-0"
                                  onClick={() => setPostJobModalShow(true)}
                                >
                                  Post Job
                                </p>
                              )}
                            </NavLink>
                          </li>
                        </ul>
                      </div>

                      <ul className="navbar-nav gap-3">
                        <li
                          className="nav-item bellIcon user_btn "
                          onClick={() => setModalShow(true)}
                        >
                          <FontAwesomeIcon
                            icon={faBell}
                            className="search_header_icon"
                          />
                        </li>

                        <li className="nav-item dropdown Login_section">
                          <div
                            className="toggle_holder dropdown-toggle show"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                          >
                            <Link className="nav-link  user_btn user_name_dropdown_holder nav-menu ">
                              {jobSeekerData?.first_name &&
                                jobSeekerData?.first_name[0]}{" "}
                              {jobSeekerData?.last_name &&
                                jobSeekerData?.last_name[0]}
                            </Link>
                            <div className="name_holder">
                              <p>
                                {" "}
                                Hi, {jobSeekerData?.first_name}{" "}
                                {jobSeekerData?.last_name}
                              </p>
                              <h6>Recruiter</h6>
                            </div>

                            <FontAwesomeIcon icon={faBarsStaggered} />
                          </div>

                          <ul
                            className="dropdown-menu profile_section"
                            aria-labelledby="actionButton"
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to={"/user-profile"}
                              >
                                My Profile
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to={"/dashboardmain"}
                              >
                                Dashboard
                              </Link>
                            </li>
                            <li onClick={() => setModalShow(true)}>
                              <Link className="dropdown-item">
                                Notification
                              </Link>
                            </li>

                            <li>
                              <Link className="dropdown-item" to={"/account"}>
                                Setting
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to={"/help"}>
                                Help Center
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to={"/privacy"}>
                                Privacy Policy
                              </Link>
                            </li>
                            <li onClick={logout}>
                              <Link className="dropdown-item">Logout</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
              </div>
            </section>
          )}

          {/* JobSeeker header */}
          {authType === "Job Seeker" && (
            <section className="Header desktopview-recruiter-header">
              <div className="top_navbar">
                <div className="container p-0 ">
                  <div className="inner_header_div">
                    <div className="left_side_navs">
                      <Link className="navbar-brand hiclousia_logo " to="/">
                        <img
                          className="hiclousia_logo"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Images/logo/header_logo.png"
                          }
                        />
                      </Link>

                      <ul className="navbar-nav ">
                        <li className="nav-item">
                          <NavLink
                            className="nav-link"
                            to="/"
                            onClick={browseJob}
                          >
                            Browse Job
                          </NavLink>
                        </li>

                        <li className="nav-item">
                          <NavLink
                            className="nav-link"
                            exact="true"
                            to="/dashboard-job"
                            activeclassname="active"
                          >
                            Dashboard
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className="nav-link"
                            exact="true"
                            to="/my-portfolio"
                            activeclassname="active"
                          >
                            My Portfolio
                          </NavLink>
                        </li>

                        <li className="nav-item">
                          <NavLink
                            className="nav-link"
                            exact="true"
                            to="https://profcyma.com/"
                            target="_blank"
                            activeclassname="active"
                          >
                            Degree
                          </NavLink>
                        </li>

                        <li
                          className="nav-item mega-menu-parent"
                          onMouseEnter={() => setShowServicesMenu(true)}
                          onMouseLeave={() => setShowServicesMenu(false)}
                        >
                          <NavLink className="nav-link" to="/career-services">
                            Services
                            <i className="fa-solid fa-angle-down ms-1"></i>
                          </NavLink>

                          <div
                            className={`mega-menu ${showServicesMenu ? "show" : ""}`}
                            onMouseEnter={() => setShowServicesMenu(true)}
                            onMouseLeave={() => setShowServicesMenu(false)}
                          >
                            <div className="mega-column">
                              <h5>Career Solutions</h5>

                              <NavLink to="/career-booster" target="_blank">
                                Featured Profile
                              </NavLink>

                              <NavLink to="/career-booster" target="_blank">
                                Profile Highlighter
                              </NavLink>

                              <NavLink to="/career-booster" target="_blank">
                                Career Booster
                              </NavLink>

                              <NavLink to="/career-booster" target="_blank">
                                Resume Writing
                              </NavLink>

                              <NavLink to="/career-booster" target="_blank">
                                Resume Builder
                              </NavLink>

                              <NavLink to="/career-booster" target="_blank">
                                Linkedin Makeover
                              </NavLink>
                            </div>

                            <div className="mega-column">
                              <h5>Prep</h5>

                              <NavLink to="/service-prep" target="_blank">
                                Interview Preparation
                              </NavLink>
                            </div>

                            <div className="mega-column">
                              <h5>Learn</h5>

                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                              >
                                Degree Programs
                              </NavLink>

                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                              >
                                Certification
                              </NavLink>

                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                              >
                                GenAI Course
                              </NavLink>
                            </div>

                            <div className="mega-column">
                              <h5>Career Advice</h5>

                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                              >
                                Career Advice
                              </NavLink>
                            </div>

                            <div className="mega-column">
                              <h5>Network</h5>

                              <NavLink to="/career-booster" target="_blank">
                                Mentor Connect
                              </NavLink>
                            </div>
                          </div>
                        </li>

                        <li className="nav-item">
                          <NavLink
                            className="nav-link"
                            exact="true"
                            to="career-solutions"
                            activeclassname="active"
                          >
                            Career Solutions{" "}
                          </NavLink>
                        </li>

                        <li className="nav-item">
                          {authToken === null ? (
                            <NavLink className="nav-link" to="/getotp">
                              <p className="mb-0">Post Job</p>
                            </NavLink>
                          ) : userdata?.type === "Recruiter" ? (
                            <NavLink className="nav-link" to="/dashboardmain">
                              <p className="mb-0">Post Job</p>
                            </NavLink>
                          ) : (
                            <span
                              className="nav-link"
                              style={{ cursor: "pointer" }}
                              onClick={() => setPostJobModalShow(true)}
                            >
                              <p className="mb-0">Post Job</p>
                            </span>
                          )}
                        </li>
                      </ul>
                    </div>

                    <ul className="navbar-nav icon_navs gap-3">
                      <li
                        className="nav-item bellIcon user_btn "
                        onClick={() => setModalShow(!modalShow)}
                      >
                        <FontAwesomeIcon
                          icon={faBell}
                          className="search_header_icon"
                        />
                      </li>

                      <li className="nav-item Login_section">
                        <div className="btn-group">
                          <div
                            className="toggle_holder dropdown-toggle show"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                          >
                            <Link className="nav-link  user_btn user_name_dropdown_holder nav-menu ">
                              {jobSeekerData?.first_name &&
                                jobSeekerData?.first_name[0]}{" "}
                              {jobSeekerData?.last_name &&
                                jobSeekerData?.last_name[0]}
                            </Link>
                            <div className="name_holder">
                              <p>
                                {" "}
                                Hi, {jobSeekerData?.first_name}{" "}
                                {jobSeekerData?.last_name}
                              </p>
                              <h6>Job Seeker</h6>
                            </div>

                            <FontAwesomeIcon icon={faBarsStaggered} />
                          </div>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="actionButton"
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to={"/view-profile"}
                              >
                                View Profile
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={() => setShowProfileMenu(true)}
                              >
                                My Account
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                to={"/dashboard-job"}
                              >
                                Dashboard
                              </Link>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/my-portfolio"}
                              >
                                My Portfolio
                              </NavLink>
                            </li>
                            {/* <li>
                              <NavLink
                                className="dropdown-item"
                                onClick={() => setModalShow(true)}
                              >
                                Notification
                              </NavLink>
                            </li> */}
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/account"}
                              >
                                Setting
                              </NavLink>
                            </li>
                            <li>
                              <NavLink className="dropdown-item" to={"/help"}>
                                Help Center
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to={"/privacy"}
                              >
                                Privacy Policy
                              </NavLink>
                            </li>
                            <li onClick={logout}>
                              <NavLink className="dropdown-item">
                                Logout
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <hr className="my-1"></hr>
                  <SearchBar
                    searchTitle={searchTitle}
                    setSearchTitle={setSearchTitle}
                    selectCity={selectCity}
                    setSelectCity={setSelectCity}
                    cities={cities}
                    selectedExperience={selectedExperience}
                    setSelectedExperience={setSelectedExperience}
                    experienceOptions={experienceOptions}
                    handleSearch={handleSearch}
                  />
                </div>
              </div>
            </section>
          )}

          {/* Main header */}
          {authToken === null && (
            <>
              {/* desktop view */}
              <section className="Header desktop-view-header">
                <div className="top_navbar">
                  <div className="container p-0 ">
                    <div className="inner_header_div">
                      <div className="left_side_navs">
                        <Link className="navbar-brand hiclousia_logo " to="/">
                          <img
                            className="hiclousia_logo"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Images/logo/header_logo.png"
                            }
                          />
                        </Link>

                        <ul className="navbar-nav ">
                          <li className="nav-item">
                            <NavLink
                              to="/"
                              onClick={browseJob}
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                            >
                              Jobs
                            </NavLink>
                          </li>

                          <li
                            className="nav-item mega-menu-parent"
                            onMouseEnter={() => setShowServicesMenu(true)}
                            onMouseLeave={() => setShowServicesMenu(false)}
                          >
                            <NavLink
                              to="/career-services"
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                            >
                              Services
                              <i className="fa-solid fa-angle-down ms-1"></i>
                            </NavLink>

                            <div
                              className={`mega-menu ${showServicesMenu ? "show" : ""}`}
                              onMouseEnter={() => setShowServicesMenu(true)}
                              onMouseLeave={() => setShowServicesMenu(false)}
                            >
                              <div className="mega-column">
                                <h5>Career Solutions</h5>

                                <NavLink to="/career-booster" target="_blank">
                                  Featured Profile
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Profile Highlighter
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Career Booster
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Resume Writing
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Resume Builder
                                </NavLink>

                                <NavLink to="/career-booster" target="_blank">
                                  Linkedin Makeover
                                </NavLink>
                              </div>

                              <div className="mega-column">
                                <h5>Prep</h5>

                                <NavLink to="/service-prep" target="_blank">
                                  Interview Preparation
                                </NavLink>
                              </div>

                              <div className="mega-column">
                                <h5>Learn</h5>

                                <NavLink
                                  to="https://profcyma.com/"
                                  target="_blank"
                                >
                                  Degree Programs
                                </NavLink>

                                <NavLink
                                  to="https://profcyma.com/"
                                  target="_blank"
                                >
                                  Certification
                                </NavLink>

                                <NavLink
                                  to="https://profcyma.com/"
                                  target="_blank"
                                >
                                  GenAI Course
                                </NavLink>
                              </div>

                              <div className="mega-column">
                                <h5>Career Advice</h5>

                                <NavLink
                                  to="https://profcyma.com/"
                                  target="_blank"
                                >
                                  Career Advice
                                </NavLink>
                              </div>

                              <div className="mega-column">
                                <h5>Network</h5>

                                <NavLink to="/career-booster" target="_blank">
                                  Mentor Connect
                                </NavLink>
                              </div>
                            </div>
                          </li>

                          <li className="nav-item">
                            <NavLink
                              to="/career-solutions"
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                            >
                              Career Solutions
                            </NavLink>
                          </li>

                          <li className="nav-item">
                            <NavLink>
                              {authToken === null ? (
                                <Link
                                  to="/getotp"
                                  className={`nav-link ${
                                    location.pathname === "/getotp" ||
                                    location.pathname === "/dashboardmain"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <p className="mb-0">Post Job</p>
                                </Link>
                              ) : userdata?.type === "Recruiter" ? (
                                <Link
                                  to="/dashboardmain"
                                  className={`nav-link ${
                                    location.pathname === "/getotp" ||
                                    location.pathname === "/dashboardmain"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <p className="mb-0">Post Job</p>
                                </Link>
                              ) : (
                                <p
                                  className="mb-0"
                                  onClick={() => setPostJobModalShow(true)}
                                >
                                  Post Job
                                </p>
                              )}
                            </NavLink>
                          </li>
                        </ul>
                      </div>

                      <ul className="navbar-nav icon_navs">
                        <li>
                          <NavLink
                            className="lighblue_btn"
                            to={"/getotp-jobseeker"}
                          >
                            Job Seekers
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className="lighblue_btn recruiter_btn"
                            to={"/getotp"}
                          >
                            Recruiters
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                    <hr className="my-1"></hr>
                    <SearchBar
                      searchTitle={searchTitle}
                      setSearchTitle={setSearchTitle}
                      selectCity={selectCity}
                      setSelectCity={setSelectCity}
                      cities={cities}
                      selectedExperience={selectedExperience}
                      setSelectedExperience={setSelectedExperience}
                      experienceOptions={experienceOptions}
                      handleSearch={handleSearch}
                    />
                  </div>
                </div>
              </section>

              {/*  mobile offcanvas */}

              <section className="Header mobile-view-header d-lg-none">
                <Navbar
                  bg="white"
                  expand={false}
                  className="shadow-sm py-2"
                  expanded={showMenu}
                >
                  <div className="container">
                    <Navbar.Brand as={Link} to="/">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/Images/logo/header_logo.png"
                        }
                        alt="Logo"
                        className="mobile-logo"
                      />
                    </Navbar.Brand>

                    <Navbar.Toggle
                      aria-controls="mobile-menu"
                      onClick={() => setShowMenu(!showMenu)}
                    />

                    <Navbar.Offcanvas
                      id="mobile-menu"
                      placement="end"
                      show={showMenu}
                      onHide={() => setShowMenu(false)} 
                      className="only_mobile_offcanvas_holder"
                    >
                      <Offcanvas.Header closeButton>
                        <Offcanvas.Title>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Images/logo/header_logo.png"
                            }
                            alt=""
                            className="mobile-logo"
                          />
                        </Offcanvas.Title>
                      </Offcanvas.Header>

                      <Offcanvas.Body>
                        <Nav className="flex-column">
                          <NavLink
                            to="/"
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={() => {
                              browseJob();
                              setShowMenu(false);
                            }}
                          >
                            Jobs
                          </NavLink>

                          <div
                            className="accordion services-accordion"
                            id="servicesAccordion"
                          >
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#servicesCollapse"
                                >
                                  Services
                                </button>
                              </h2>

                              <div
                                id="servicesCollapse"
                                className="accordion-collapse collapse"
                                data-bs-parent="#servicesAccordion"
                              >
                                <div className="accordion-body p-0">
                                  {/* Main Services Page */}
                                  <NavLink
                                    to="/career-booster"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    All Services
                                  </NavLink>

                                  <NavLink
                                    to="/career-booster"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Featured Profile
                                  </NavLink>

                                  <NavLink
                                    to="/career-booster"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Profile Highlighter
                                  </NavLink>

                                  <NavLink
                                    to="/career-booster"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Career Booster
                                  </NavLink>

                                  <NavLink
                                    to="/career-booster"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Resume Writing
                                  </NavLink>

                                  <NavLink
                                    to="/career-booster"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Resume Builder
                                  </NavLink>

                                  <NavLink
                                    to="/service-prep"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Interview Preparation
                                  </NavLink>

                                  <NavLink
                                    to="https://profcyma.com/"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Degree Programs
                                  </NavLink>

                                  <NavLink
                                    to="https://profcyma.com/"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Certification
                                  </NavLink>

                                  <NavLink
                                    to="https://profcyma.com/"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    GenAI Course
                                  </NavLink>

                                  <NavLink
                                    to="https://profcyma.com/"
                                    target="_blank"
                                    className="submenu-link"
                                    onClick={() => setShowMenu(false)}
                                  >
                                    Career Advice
                                  </NavLink>
                                </div>
                              </div>
                            </div>
                          </div>

                          <NavLink
                            to="/career-solutions"
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={() => {
                              setShowMenu(false);
                            }}
                          >
                            Career Solutions
                          </NavLink>

                          {authToken === null ? (
                            <NavLink
                              to="/getotp"
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={() => setShowMenu(false)}
                            >
                              Post Job
                            </NavLink>
                          ) : userdata?.type === "Recruiter" ? (
                            <NavLink
                              to="/dashboardmain"
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={() => setShowMenu(false)}
                            >
                              Post Job
                            </NavLink>
                          ) : (
                            <span
                              className="nav-link"
                              onClick={() => {
                                setPostJobModalShow(true);
                                setShowMenu(false);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Post Job
                            </span>
                          )}
                        </Nav>
                        <div className="navbar-nav icon_navs mobile_btn_holder">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "lighblue_btn active" : "lighblue_btn"
                            }
                            to="/getotp-jobseeker"
                            onClick={() => setShowMenu(false)}
                          >
                            Job Seekers
                          </NavLink>

                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "lighblue_btn active" : "lighblue_btn "
                            }
                            to="/getotp"
                            onClick={() => setShowMenu(false)}
                          >
                            Recruiters
                          </NavLink>
                        </div>
                      </Offcanvas.Body>
                    </Navbar.Offcanvas>
                  </div>
                </Navbar>
              </section>
            </>
          )}

          {/* Chat Bot */}
          <section className="sms-lottie">
            <div className="lottie">
              <Sms />
            </div>
          </section>

          {/* mobile-view-start */}

          {/* Recruiter header Mobile*/}
          {authType === "Recruiter" && (
            <section className="Header mobileview-recruiter-header">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-6 ps-0">
                    <div className=" my-2">
                      <div className="d-flex">
                        <button
                          className="btn menuBtn pt-1"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasmobileapp"
                          aria-controls="offcanvasExample"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-bars"
                            className="me-1"
                          />
                        </button>

                        <Link className="navbar-brand hiclousia_logo " to="/">
                          <img
                            className="hiclousia_logo"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Images/logo/header_logo.png"
                            }
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 ">
                    <nav className="d-flex justify-content-end align-items-center g-2">
                      <Link to="https://profcyma.com/" target="_blank">
                        <div className="solar_div">
                          <img
                            src="/assets/Images/header/PROFCYMA-LLP.png"
                            className="header_img"
                          />
                        </div>
                      </Link>

                      <div className="nav-item bellIcon user_btn ">
                        {" "}
                        <FontAwesomeIcon
                          icon={faBell}
                          className="search_header_icon"
                          onClick={() => setModalShow(true)}
                        />
                      </div>
                      <div className="nav-item ">
                        <div className="nav-link  user_btn  nav-menu show ">
                          {jobSeekerData?.first_name &&
                            jobSeekerData?.first_name[0]}{" "}
                          {jobSeekerData?.last_name &&
                            jobSeekerData?.last_name[0]}{" "}
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </section>
          )}

          {/* JobSeeker header Mobile */}
          {authType === "Job Seeker" && (
            <section className="Header mobileview-recruiter-header">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-6 ps-0">
                    <div className=" my-2">
                      <div className="d-flex align-items-center">
                        <button
                          className="btn menuBtn pt-1"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasmobileapp"
                          aria-controls="offcanvasExample"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-bars"
                            className="me-1"
                          />
                        </button>

                        {/* <Link className="mt-1" to="/">
                          <span>Back to Dashboard</span>
                        </Link> */}
                        <Link className="navbar-brand hiclousia_logo " to="/">
                          <img
                            className="hiclousia_logo"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Images/logo/header_logo.png"
                            }
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 ">
                    <nav className="d-flex justify-content-end  align-items-center gap-3">
                      <div className="nav-item bellIcon user_btn  ">
                        {" "}
                        <FontAwesomeIcon
                          icon={faBell}
                          className="search_header_icon"
                          onClick={() => setModalShow(true)}
                        />
                      </div>
                      <div className="nav-item ">
                        <div className="nav-link  user_btn  nav-menu show ">
                          {" "}
                          {jobSeekerData?.first_name &&
                            jobSeekerData?.first_name[0]}{" "}
                          {jobSeekerData?.last_name &&
                            jobSeekerData?.last_name[0]}{" "}
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </section>
          )}

          {/* mobile app view offcanvas start */}

          {/* Recruiter header Canvas */}
          {authType === "Recruiter" && (
            <div className="mobile-app-offcanvas">
              <div
                className="offcanvas offcanvas-start only_mobile_offcanvas_holder"
                tabIndex="-1"
                id="offcanvasmobileapp"
                aria-labelledby="offcanvasExampleLabel"
              >
                <div className="offcanvas-header">
                  {/* <h5 className="offcanvas-title" id="offcanvasExampleLabel">Offcanvas</h5> */}
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="offcanvas-body pt-0">
                  <div className="row">
                    <div className="all-pages">
                      <Link to={"/dashboardmain"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder ">
                            <p>Dashboard</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/talentPool"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Talent Pool</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/getotp"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Job Packages</p>
                          </div>
                        </div>
                      </Link>

                      <div
                        className="accordion services-accordion"
                        id="recruiterServicesAccordion"
                      >
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#recruiterServicesCollapse"
                            >
                              Services
                            </button>
                          </h2>
                          <div
                            id="recruiterServicesCollapse"
                            className="accordion-collapse collapse"
                            data-bs-parent="#recruiterServicesAccordion"
                          >
                            <div className="accordion-body p-0">
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Featured Profile
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Profile Highlighter
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Career Booster
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Resume Writing
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Resume Builder
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Linkedin Makeover
                              </NavLink>
                              <NavLink
                                to="/service-prep"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Interview Preparation
                              </NavLink>
                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Degree Programs
                              </NavLink>
                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Certification
                              </NavLink>
                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                GenAI Course
                              </NavLink>
                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Career Advice
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Mentor Connect
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>

                      <Link to={"/career-solutions"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Career Solutions</p>
                          </div>
                        </div>
                      </Link>

                      {userdata?.type === "Recruiter" ? (
                        <Link to="/dashboardmain">
                          <div data-bs-dismiss="offcanvas" aria-label="Close">
                            <div className="page-holder">
                              <p>Post Job</p>
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <div
                          onClick={() => setPostJobModalShow(true)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="page-holder">
                            <p>Post Job</p>
                          </div>
                        </div>
                      )}

                      <hr
                        className="my-2"
                        style={{ borderColor: "#ffffff33" }}
                      />

                      <Link to={"/user-profile"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>My Profile</p>
                          </div>
                        </div>
                      </Link>

                      <Link onClick={() => setModalShow(true)}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Notifications ({notifications?.length})</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/account"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Settings</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/help"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Help Center</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/privacy"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Privacy Policy</p>
                          </div>
                        </div>
                      </Link>

                      <Link onClick={logout}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Logout</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Job Seeker header Canvas */}
          {authType === "Job Seeker" && (
            <div className="mobile-app-offcanvas">
              <div
                className="offcanvas offcanvas-start only_mobile_offcanvas_holder"
                tabIndex="-1"
                id="offcanvasmobileapp"
                aria-labelledby="offcanvasExampleLabel"
              >
                <div className="offcanvas-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="offcanvas-body pt-0">
                  <div className="row">
                    <div className="all-pages">
                      <Link to={"/"} onClick={browseJob}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Browse Job</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/dashboard-job"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Dashboard</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/my-portfolio"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>My Portfolio</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"https://profcyma.com/"} target="_blank">
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Degree</p>
                          </div>
                        </div>
                      </Link>

                      <div
                        className="accordion services-accordion " 
                        id="jobseekerServicesAccordion"
                      >
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#jobseekerServicesCollapse"
                            >
                              Services
                            </button>
                          </h2>
                          <div
                            id="jobseekerServicesCollapse"
                            className="accordion-collapse collapse"
                            data-bs-parent="#jobseekerServicesAccordion"
                          >
                            <div className="accordion-body p-0">
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Featured Profile
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Profile Highlighter
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Career Booster
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Resume Writing
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Resume Builder
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Linkedin Makeover
                              </NavLink>
                              <NavLink
                                to="/service-prep"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Interview Preparation
                              </NavLink>
                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Degree Programs
                              </NavLink>
                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Certification
                              </NavLink>
                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                GenAI Course
                              </NavLink>
                              <NavLink
                                to="https://profcyma.com/"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Career Advice
                              </NavLink>
                              <NavLink
                                to="/career-booster"
                                target="_blank"
                                className="submenu-link"
                                data-bs-dismiss="offcanvas"
                              >
                                Mentor Connect
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>

                      <Link to={"/career-solutions"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Career Solutions</p>
                          </div>
                        </div>
                      </Link>

                      {userdata?.type === "Recruiter" ? (
                        <Link to="/dashboardmain">
                          <div data-bs-dismiss="offcanvas" aria-label="Close">
                            <div className="page-holder">
                              <p>Post Job</p>
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <div
                          onClick={() => setPostJobModalShow(true)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="page-holder">
                            <p>Post Job</p>
                          </div>
                        </div>
                      )}

                      

                      <Link to={"/view-profile"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>View Profile</p>
                          </div>
                        </div>
                      </Link>

                      <div
                        onClick={() => setShowProfileMenu(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="page-holder">
                          <p>My Account</p>
                        </div>
                      </div>

                      <Link onClick={() => setModalShow(true)}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Notification ({notifications?.length})</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/account"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Setting</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/help"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Help Center</p>
                          </div>
                        </div>
                      </Link>

                      <Link to={"/privacy"}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Privacy Policy</p>
                          </div>
                        </div>
                      </Link>

                      <Link onClick={logout}>
                        <div data-bs-dismiss="offcanvas" aria-label="Close">
                          <div className="page-holder">
                            <p>Logout</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      <Login_As_Modal
        text={
          userdata?.type === "Recruiter"
            ? "Login As Job Seeker"
            : "Login As Recruiter"
        }
        loginRoute={
          userdata?.type === "Recruiter" ? "/getotp-jobseeker" : "/getotp"
        }
        show={modalPostJobModalShow}
        onHide={() => setPostJobModalShow(false)}
      />

      <ProfileOffcanvas
        showMenu={showProfileMenu}
        setShowMenu={setShowProfileMenu}
        jobSeekerData={jobSeekerData}
        logout={logout}
      />
    </>
  );
};

export default SabKaBaap;
